export const initEmail = () => ({
  type: "INIT_EMAIL"
});

export const emailRequest = () => ({
  type: "EMAIL_PENDING"
});

export const emailSuccess = response => ({
  type: "EMAIL_FULFILLED",
  payload: response
});

export const emailFailure = error => ({
  type: "EMAIL_REJECTED",
  payload: error
});



// WEBPACK FOOTER //
// ./src/actions/actions/emailing.js